import React, { useRef } from "react";

function DragAndDrop({ files, setFiles }) {
  const inputRef = useRef(null);

  const handleDrop = (event) => {
    event.preventDefault();
    const { dataTransfer } = event;
    const { files: droppedFiles } = dataTransfer;

    const newFiles = Array.from(droppedFiles);
    setFiles([...files, ...newFiles]);
  };

  const handleDragOver = (event) => {
    event.preventDefault();
  };

  const handleFileDelete = (fileIndex, event) => {
    event.preventDefault();
    const newFiles = [...files];
    newFiles.splice(fileIndex, 1);
    setFiles(newFiles);
  };

  const handleOpenFileDialog = () => {
    if (inputRef.current) {
      inputRef.current.click();
    }
  };

  const handleFileInputChange = (event) => {
    const newFiles = Array.from(event.target.files);
    setFiles([...files, ...newFiles]);
    // Clear the input value to allow selecting the same file again
    event.target.value = null;
  };

  return (
    <div className="drag-and-drop-container col-12" onDrop={handleDrop} onDragOver={handleDragOver}>
      <input
        type="file"
        accept="*/*"
        multiple
        ref={inputRef}
        style={{ display: "none" }}
        onChange={handleFileInputChange}
      />
      {files?.length === 0 ? (
        <p className="text-center" onClick={handleOpenFileDialog}>
          Please click here to select or drop your attachments
        </p>
      ) : (
        <div className="drag-and-drop">
          <div className="file-list">
            {files?.map((file, index) => (
              <div key={index} className="file-item">
                <span className="file-name">{file.name}</span>
                <button className="delete-button" onClick={(event) => handleFileDelete(index, event)}>
                  Remove
                </button>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

export default DragAndDrop;